module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('nav', [_c('ul', {
    staticClass: "pagination",
    class: [_vm.size]
  }, [_c('li', {
    class: {
      'disabled': _vm.current == 1
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.setCurrent(1)
      }
    }
  }, [_vm._v(" 首页 ")])]), _vm._v(" "), _c('li', {
    class: {
      'disabled': _vm.current == 1
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.setCurrent(_vm.current - 1)
      }
    }
  }, [_vm._v(" 上一页 ")])]), _vm._v(" "), _vm._l((_vm.grouplist), function(p) {
    return _c('li', {
      class: {
        'active': _vm.current == p.val
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.setCurrent(p.val)
        }
      }
    }, [_vm._v(" " + _vm._s(p.text) + " ")])])
  }), _vm._v(" "), _c('li', {
    class: {
      'disabled': _vm.current == _vm.page
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.setCurrent(_vm.current + 1)
      }
    }
  }, [_vm._v(" 下一页")])]), _vm._v(" "), _c('li', {
    class: {
      'disabled': _vm.current == _vm.page
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.setCurrent(_vm.page)
      }
    }
  }, [_vm._v(" 尾页 ")])])], true), _vm._v(" "), _c('ul', {
    staticClass: "pagination info pull-right",
    class: [_vm.size]
  }, [_c('li', [_c('span', [_vm._v(" 共 " + _vm._s(_vm.total) + "  条数据 ")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(" 共 " + _vm._s(_vm.page) + " 页 ")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(" 每页显示 " + _vm._s(_vm.display) + "  条数据 ")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(" 当前 " + _vm._s(_vm.current) + " 页 ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-54c5ab1a!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/pagination.vue
// module id = 314
// module chunks = 2